import api from './api';

const milestoneService = {
  getAllMilestones: async (params = {}) => {
    try {
      const response = await api.get('/milestones', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching milestones:', error);
      throw error;
    }
  },

  getMilestoneById: async (id) => {
    try {
      const response = await api.get(`/milestones/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching milestone with ID ${id}:`, error);
      throw error;
    }
  },

  createMilestone: async (milestoneData) => {
    try {
      const response = await api.post('/milestones', milestoneData);
      return response.data;
    } catch (error) {
      console.error('Error creating milestone:', error);
      throw error;
    }
  },

  updateMilestone: async (id, milestoneData) => {
    try {
      const response = await api.put(`/milestones/${id}`, milestoneData);
      return response.data;
    } catch (error) {
      console.error(`Error updating milestone with ID ${id}:`, error);
      throw error;
    }
  },

  deleteMilestone: async (id) => {
    try {
      const response = await api.delete(`/milestones/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting milestone with ID ${id}:`, error);
      throw error;
    }
  },

  getMilestoneStats: async () => {
    try {
      const response = await api.get('/milestones/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching milestone stats:', error);
      throw error;
    }
  }
};

export default milestoneService;

